import App from './routes/App';

export default App;